<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDealsStore } from 'dashboard/stores/deals';

import Button from 'dashboard/components-next/button/Button.vue';
import DealForm from 'dashboard/components-next/Deals/DealForm/DealForm.vue';

// Criacao de negociacao na coluna esquerda (no lugar do antigo dialogo
// central): mesmo formulario da edicao, em modo "create".
defineProps({
  initialValues: { type: Object, default: null },
  defaultPipelineId: { type: Number, default: null },
  conversationId: { type: Number, default: null },
});

const emit = defineEmits(['back', 'created']);

const { t } = useI18n();
const dealsStore = useDealsStore();

const dealFormRef = ref(null);
const isFormInvalid = computed(() => dealFormRef.value?.isFormInvalid);
const isCreating = computed(() => dealsStore.uiFlags.creatingItem);

const handleCreate = async () => {
  const created = await dealFormRef.value?.save();
  if (created) emit('created', created);
};
</script>

<template>
  <div
    class="thin-scrollbar flex flex-col gap-4 w-full h-full overflow-y-auto border-r border-n-weak bg-n-solid-1 p-4"
  >
    <div class="flex items-center gap-2">
      <Button
        icon="i-lucide-arrow-left"
        variant="ghost"
        color="slate"
        size="xs"
        @click="emit('back')"
      />
      <span
        class="flex items-center gap-1.5 text-sm font-medium text-n-slate-12"
      >
        <span class="truncate">{{ t('DEALS.CREATE.TITLE') }}</span>
        <span
          class="i-lucide-dollar-sign size-4 shrink-0 text-n-slate-11"
          aria-hidden="true"
        />
      </span>
    </div>

    <DealForm
      ref="dealFormRef"
      mode="create"
      :initial-values="initialValues"
      :default-pipeline-id="defaultPipelineId"
      :conversation-id="conversationId"
    />

    <div class="flex items-center w-full gap-3 pb-4">
      <Button
        :label="t('DEALS.CREATE.ACTIONS.SAVE')"
        color="blue"
        :is-loading="isCreating"
        :disabled="isCreating || isFormInvalid"
        @click="handleCreate"
      />
      <Button
        :label="t('DEALS.CREATE.ACTIONS.CANCEL')"
        variant="faded"
        color="slate"
        :disabled="isCreating"
        @click="emit('back')"
      />
    </div>
  </div>
</template>
